export const FIELDS = {
  reportHazardousWasteAllocationTimes: 'reportHazardousWasteAllocationTimes',
  reportHazardousWasteCode: 'reportHazardousWasteCode',
  reportHazardousWasteDate: 'reportHazardousWasteDate',
  reportHazardousWasteDateRenew: 'reportHazardousWasteDateRenew',
  reportHazardousWasteFormProcessing: 'reportHazardousWasteFormProcessing',
  reportHazardousWasteMass: 'reportHazardousWasteMass',
};



// WEBPACK FOOTER //
// ./src/containers/Coso/CosoView/ChiTietCosoPanel/constants.js